import {
  currencyString,
  formatDate,
  isDefined,
  isFullPayoffPayment,
  isInstallmentBeforeScheduledDate,
  isLocOnOrBeforeScheduledDate,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessageEarlyAmountDue: UseMessageT = (props) => {
  const {
    fullPayoffAmount,
    isAutopay,
    isAutopayPending,
    loanStatus,
    isFullPayoffDisabled,
    isNextMinimumPaymentDisabled,
    isMultiple,
    paymentAmount,
    paymentDate,
    productType,
    scheduledAmount,
    scheduledDate,
  } = props;

  if (!isDefined(paymentAmount)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
    || !isDefined(scheduledDate)
    || !isDefined(fullPayoffAmount)
  ) { return undefined; }

  const logicHelperProps = {
    paymentDate,
    productType,
    scheduledDate,
  };

  const fullPayoffProps = {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  };

  // NCFE-10081 (D-2)
  if (isAutopay
    && !isAutopayPending
    && !isNextMinimumPaymentDisabled
    && loanStatus === 'current'
    && paymentAmount >= scheduledAmount
    && !isFullPayoffPayment(fullPayoffProps)
    && (
      isInstallmentBeforeScheduledDate(logicHelperProps)
        || isLocOnOrBeforeScheduledDate(logicHelperProps)
    )
  ) {
    return (
      <p>
        Your AutoPay{' '}
        {isMultiple ? 'payments totaling ' : 'payment of '}
        {currencyString(scheduledAmount)} scheduled for {formatDate(scheduledDate)}
        <span className="fw-bold"> will be canceled.</span>
      </p>
    );
  }

  return undefined;
};
